import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

interface HeaderProps {
  children: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ children }) => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const closeNav = () => {
    setIsNavOpen(false);
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Metropolitan Barbershop" />
          </Link>
        </div>
        <button className="mobile-nav-toggle" onClick={toggleNav}>
          {isNavOpen ? '✕' : '☰'}
        </button>
        <nav className={`nav ${isNavOpen ? 'active' : ''}`}>
          {React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
              const originalOnClick = child.props.onClick;
              return React.cloneElement(child as React.ReactElement<any>, {
                onClick: () => {
                  if (originalOnClick) {
                    originalOnClick();
                  }
                  closeNav();
                },
              });
            }
            return child;
          })}
        </nav>
      </div>
    </header>
  );
};

export default Header; 